module.exports = __webpack_public_path__ + "img/icon_line.7c0d1120.svg";